<template>
  <transition name="fade" mode="out-in">
    <div class="marketplace left">
      <img src="../assets/prodotto.png" style="margin-bottom: 30px" />
    </div>
  </transition>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Marketplace",
  components: {}
};
</script>

<style lang="less" scoped>
.padding {
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
}
.p-top {
  padding-top: 30px;
}
.lista {
  width: 100%;
  overflow: auto;
  padding-left: 10px;
}
</style>
